/* ==========================================================================
facenotfound.com — boot-up terminal intro (behavior)
--------------------------------------------------------------------------
Types out a short "connecting to a monitored system" sequence, then
fades the overlay out. Shows once per browser session. Any keypress,
click, or tap instantly completes the typing and moves to fade-out.
========================================================================== */

(function () {
'use strict';

var SEEN_KEY = 'fnf_boot_seen';
if (sessionStorage.getItem(SEEN_KEY) === 'true') {
var existing = document.getElementById('fnf-boot');
if (existing) existing.remove();
return;
}

var LINES = [
'> ESTABLISHING SECURE UPLINK...',
'> NODE: FACENOTFOUND.COM',
'> SUBJECT STATUS: MONITORED',
'> ANONYMITY PROTOCOLS.......... [ENGAGING]',
'> ACCESS GRANTED.'
];
var FULL_TEXT = LINES.join('\n');

var root = document.getElementById('fnf-boot');
if (!root) return;
var textEl = root.querySelector('.fnf-boot-text');
if (!textEl) return;

var reduceMotion = window.matchMedia &&
window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function finish() {
sessionStorage.setItem(SEEN_KEY, 'true');
root.classList.add('fnf-boot--done');
document.body.style.overflow = '';
setTimeout(function () {
if (root.parentNode) root.remove();
}, 800);
}

document.body.style.overflow = 'hidden';

if (reduceMotion) {
textEl.textContent = FULL_TEXT;
setTimeout(finish, 700);
return;
}

var i = 0;
var skipped = false;
var timer = null;

function typeNext() {
if (skipped) return;
if (i >= FULL_TEXT.length) {
timer = setTimeout(finish, 650);
return;
}
textEl.textContent = FULL_TEXT.slice(0, i + 1);
var ch = FULL_TEXT[i];
i++;
var delay = ch === '\n' ? 220 : 16 + Math.random() * 26;
timer = setTimeout(typeNext, delay);
}

function skip() {
if (skipped) return;
skipped = true;
clearTimeout(timer);
textEl.textContent = FULL_TEXT;
setTimeout(finish, 350);
}

root.addEventListener('click', skip);
window.addEventListener('keydown', skip, { once: true });

typeNext();
})();
